import { merge } from '../../helper';

import isEmptyArray from '../../general/isEmpty/isEmptyArray';
import isEmptyObject from '../../general/isEmpty/isEmptyObject';

import * as exTable from '../table';

import * as exButtons from './buttons';
import * as exRender from './render';
import * as exSelect from './select';
import * as exUtils from './utils';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build: Record<string, any> = {
        elements: {},
    };

    // Create element (table)
    const table = exTable.create({
        merge: {
            ...defConfig,
            data: null,
            select: null,
        },
        class: {
            add: 'table treetable',
        },
    });
    build.element = table.element;
    build.elements = table.elements;

    // ------------------------------------------------------------------------

    // Settings
    settings(build, defConfig);

    // ------------------------------------------------------------------------

    // Render Start
    if (build.element instanceof HTMLElement) {
        exRender.start(build.element, defConfig);
    }

    // ------------------------------------------------------------------------

    // Return
    return build;
}

function settings(build: Record<string, any>, config: Record<string, any> = {}): void {
    const elements = build.elements;

    // If using data
    if (!isEmptyArray(config.data)) {
        exUtils.data(elements.element, config);
    }

    // ------------------------------------------------------------------------

    // If using buttons
    if (!isEmptyObject(config.buttons)) {
        exButtons.start(elements.element, config.buttons);
    }

    // ------------------------------------------------------------------------

    // If using select
    if (config.select === true || !isEmptyObject(config.select)) {
        exSelect.start(elements.element, config.select);
    }
}

// ----------------------------------------------------------------------------

export { create };
